import dayjs from "dayjs";

/**
* @Description:时间格式化
*/
export function dateFormat(date,template='YYYY.MM.DD HH:mm') {
    return dayjs(date).format(template)
}